
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"46","height":"46","rx":"8","fill":"url(#paint0_linear)"}}),_c('path',{attrs:{"d":"M34.334 19.33c.416 0 .75-.375.624-.791l-1-3.998c-.082-.333-.332-.541-.624-.541h-4.122l1.04 5.33h4.082zM27.838 14h-4.165v5.33h5.247L27.838 14zm6.496 7.995H33.5l.166-1.332h-21.32l.166 1.332h-.832a.685.685 0 00-.667.666v.667c0 .375.292.666.667.666h1.082l.916 7.33v.665c0 .375.292.667.666.667h1.333a.685.685 0 00.666-.667v-.666H29.67v.666c0 .375.291.667.666.667h1.333a.685.685 0 00.666-.667v-.666l.916-7.329h1.083a.685.685 0 00.666-.666v-.666c0-.334-.333-.667-.666-.667zm-3.79 7.33H15.428l-.833-6.663h16.782l-.833 6.662zM11.681 19.33h4.039L16.76 14h-4.08c-.333 0-.583.208-.666.541l-1 3.998c-.083.416.208.791.667.791zM22.34 14h-4.206l-1.083 5.33h5.289V14z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"0","y1":"0","x2":"51.265","y2":"6.904","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#01A48B"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#41BB2E"}})])])])
          )
        }
      }
    